// NPM Imports
import React from "react";
import { Toastr } from "../../revvComponents";

// Services Imports
import { authEmailVerificationService } from "../../actions/AuthActions/authService";

// Internal Imports
import { GlobalUtils } from "../../utils";

// Destructuring
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;

const NotifyBanner = () => {
  const userData = readDataFromLocalStorage("revvsalesUser");

  const verifyEmailHandler = () => {
    authEmailVerificationService()
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Email Verification link has been sent to your mail.",
          timeout: 3000,
        });
      })
      .catch(error => {
        console.error(`SignUp => authEmailVerificationService => ${error}`);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };
  // Show the NotifyBanner Component when,
  // user is authenticated and email id is not verified
  if (userData && !userData.is_verified) {
    return (
      <div className="notifybanner-wrapper">
        <div className="notifybanner-content">
          Please verify your email address
          <span className="email-address"> {userData.user_email}</span> or
          <button
            type="button"
            onClick={verifyEmailHandler}
            className="notifybanner-button"
            data-test="notifybanner-resend-btn">
            Resend
          </button>
        </div>
      </div>
    );
  }
  return null;
};

export default NotifyBanner;
